export const companyRoleEnum = {
  admin: 'admin',
  editor: 'editor',
  viewer: 'viewer',
  none: 'none',
} as const

export type CompanyRoleEnum = (typeof companyRoleEnum)[keyof typeof companyRoleEnum]

export type CompanyRole = CompanyRoleEnum